const HOC = (props) => props.children;

export default HOC;
